export default __webpack_public_path__ + "static/media/wuyeFour.67b66c89.png";